import React, { useEffect, useRef, useState } from "react";
import Tabs from "./Tabs";
import Panel from "./Panel";
import { ClientProvider } from "../../shared/hooks/client-hook";
import ViewPort from "./ViewPort";
import ModelInstansiator from "./ModelInstansiator";
import { OrbitControls } from "@react-three/drei";
import Sky from "../../shared/components/three/Sky";
import CameraDummy from "./CameraDummy";
import Sound from "../Viewer/Sound";

const Editor = () => {
  return (
    <ClientProvider>
      <div className="absolute flex top-0 right-0 bottom-0 w-full">
        <div className="flex-auto relative bg-gray">
          <ViewPort>
            <ModelInstansiator />
            <OrbitControls dampingFactor={0.1} />
            <gridHelper args={[100, 100, 100]} />
            <ambientLight intensity={0.5} />
            <CameraDummy />
            <Sky />
          </ViewPort>
        </div>
        <div className="flex-none shadow-lg z-10 relative bg-gray-800 h-full w-[500px]">
          <div className="flex h-full">
            <Panel />
            <Tabs />
          </div>
        </div>
      </div>
    </ClientProvider>
  );
};

export default Editor;
